import { useReveal } from "@/hooks/useReveal";
import { useT } from "@/i18n/LanguageProvider";

export default function Problem() {
    const { t } = useT();
    const r1 = useReveal();
    const r2 = useReveal();
    const r3 = useReveal();

    return (
        <section
            id="story"
            data-testid="problem-section"
            aria-labelledby="problem-headline"
            className="relative py-24 md:py-40 bg-secondary"
        >
            <div className="max-w-7xl mx-auto px-6 md:px-12">
                <div className="flex items-center gap-6 mb-14">
                    <span aria-hidden="true" className="font-display italic text-6xl md:text-8xl text-primary/30 leading-none">
                        01
                    </span>
                    <div className="text-xs uppercase tracking-[0.3em] text-accent font-semibold">
                        {t("problem.chapter")}
                    </div>
                </div>

                <h2
                    ref={r1}
                    id="problem-headline"
                    data-testid="problem-headline"
                    className="reveal font-display text-5xl md:text-7xl lg:text-8xl tracking-tight text-primary leading-[0.95] max-w-5xl"
                >
                    {t("problem.headline.prefix")} <em className="text-accent">{t("problem.headline.accent")}</em> {t("problem.headline.suffix")}
                </h2>

                <div className="mt-16 md:mt-24 grid md:grid-cols-12 gap-10 md:gap-16">
                    <div ref={r2} className="reveal md:col-span-7 md:col-start-2 space-y-6 text-lg md:text-xl leading-relaxed text-foreground/85">
                        <p>{t("problem.p1")}</p>
                        <p>{t("problem.p2")}</p>
                        <p className="font-display italic text-2xl md:text-3xl text-primary pt-4">
                            {t("problem.until")}
                        </p>
                    </div>

                    <div ref={r3} className="reveal md:col-span-3 md:col-start-9 space-y-8 pt-6 border-t-2 border-primary/15 md:border-t-0 md:border-l-2 md:pl-8">
                        <div>
                            <h3 className="text-xs uppercase tracking-[0.25em] text-accent font-semibold mb-2">
                                {t("problem.gap.label")}
                            </h3>
                            <p className="text-base text-foreground/75 leading-relaxed">
                                {t("problem.gap.body")}
                            </p>
                        </div>
                        <div>
                            <h3 className="text-xs uppercase tracking-[0.25em] text-accent font-semibold mb-2">
                                {t("problem.fix.label")}
                            </h3>
                            <p className="text-base text-foreground/75 leading-relaxed">
                                {t("problem.fix.body")}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
